export const environment = {
  production: true,
  apiDomain: 'https://api.event.no/',
  // apiDomain: 'https://localhost:44370/',
  staticContent: 'C:/@Websites/StaticResources/Event.API',
  imgFxDomain: 'https://event.imgfx.net/{mode}/size-{size}/',
  imgFxActive: true,
  cookieVersion: 1,
};
